import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, HostBinding, Input } from "@angular/core";
import { ConfigSearchService } from "./config-search.service";
import { INode } from "../../Configuration/INode";
import { OxeModelService } from "../../oxe-model-service/oxe-model.service";

@Component({
    selector: "wbm-config-search-detail",
    templateUrl: "config-search-detail.component.html",
    styleUrls: ['../../../assets/theme/css/ConfigSearchDetail.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfigSearchDetailComponent implements OnInit {
    @HostBinding() class = 'home-box flex-item-fluid flex-container-v nowrap relativeto mw45';
    @Input() public rootNode1: INode;
    showResult: boolean = false;
    processResult: Array<Object> = [];
    attributeGroups: Array<string> = ["test", "Node", "Attribute"];
    NodeResult: Array<Object> = [];
    AttributeResult: Array<string> = [];
    ValueResult: Array<string> = [];
    searchResult = [];
    resultHierachy = [];
    lastLocatedItems = [];
    count = 0;

    matMenuTimer: any;

    selectedGroupId: number = 1;
    constructor(private _searchservice: ConfigSearchService,
        private cd: ChangeDetectorRef,
        private _oxeservice: OxeModelService) { }

    ngOnInit() {
        this._searchservice.finalResultChanges()
            .subscribe((data) => {
                this.processResult = [];
                this.searchResult = data;
                this._searchservice.showSearch = true;
                this.cd.markForCheck();
            })
    }

    public onGroupClicked(i) {
        this.selectedGroupId = i;
        if (i === 1)
            this.processResult = this.NodeResult;
        else
            this.processResult = [];
    }

    public compare(a, b) {
        if (a.type > b.type) {
            return -1;
        }
        if (a.type < b.type) {
            return 1;
        }
        return 0;
    }

    public locateClick(search) {
        this.matMenuTimer = setTimeout(() => {
            console.log("single clicked");
            if (!this.matMenuTimer) return;
            this.locateSearch(search)
        }, 300);

    }

    public locateSearch(search) {
        this.resultHierachy = search.searchHierachy;
        let itemsToLocate = search.searchHierachy.map(x => x.name);
        if (JSON.stringify(itemsToLocate) == JSON.stringify(this.lastLocatedItems)) {
            if (!this._searchservice.isTreeToggle) {
                this._oxeservice.setLoader(true);
                setTimeout(() => {
                    this._oxeservice.setLoader(false);
                    return;
                }, 500);
            } else {
                this._searchservice.isTreeToggle = false;
                this.lastLocatedItems = itemsToLocate.slice();
                let nodes = [...this.rootNode1.subNodes];
                this.locateNodes(nodes, itemsToLocate);
            }
        } else {
            this._searchservice.isTreeToggle = false;
            this.lastLocatedItems = itemsToLocate.slice();
            let nodes = [...this.rootNode1.subNodes];
            this.locateNodes(nodes, itemsToLocate);
        }

    }

    public locateDoubleClick(search) {
        console.log("Dbl Clicked...");
        clearTimeout(this.matMenuTimer);
        this.matMenuTimer = undefined;
        console.log("timer set off");
        this.locateSearch(search);
    }

    public locateNodes(nodes, itemsToLocate) {
        this._oxeservice.setLoader(true);
        var self = this;

        setTimeout(() => {
            for (let j = 0; j < nodes.length; j++) {
                if (itemsToLocate[0] === nodes[j].name) {
                    itemsToLocate.shift();
                    this.count++;
                    if (itemsToLocate.length == 0) {
                        self.selectNode(nodes[j]);
                        self._oxeservice.setLoader(false);
                        this.count = 0;
                        break;
                    } else if ((nodes[j].isClassNode && this.resultHierachy[this.count].canLocate)) {
                        if (this.resultHierachy[this.count].type === "Node" || this.resultHierachy[this.count].type === "Attribute") {
                            let filter = {};
                            nodes[j].isExpanded = false;
                            delete nodes[j].subNodes;
                            if (this.resultHierachy[this.count + 1] != undefined) {
                                if (this.resultHierachy[this.count].type === "Attribute" && this.resultHierachy[this.count].canLocate) {
                                    filter = {
                                        "and": [
                                            {
                                                "==": [
                                                    {
                                                        "var": nodes[j].structure.id
                                                    },
                                                    itemsToLocate[itemsToLocate.length - 1]
                                                ]
                                            }
                                        ]
                                    }
                                    console.log("filter as ", filter);
                                    nodes[j].setFilterCondition(filter);
                                }
                            }

                            self._oxeservice.retrieveSubNodes(nodes[j], true)
                                .subscribe(() => {
                                    nodes[j].isExpanded = true;
                                    nodes[j].resetFilterCondition();
                                    let subNodes;
                                    if (nodes[j].isOneInstance)
                                        subNodes = nodes[j].subNodes[0].subNodes;
                                    else
                                        subNodes = nodes[j].subNodes;

                                    if (subNodes.length == 0) {
                                        self.selectNode(nodes[j]);
                                        this.count = 0;
                                        self._oxeservice.setLoader(false);
                                    } else {
                                        if (this.resultHierachy[this.count].type === "Attribute") {
                                            itemsToLocate.shift();
                                            this.count++;
                                        }
                                        self.locateNodes(subNodes, itemsToLocate);
                                    }
                                })
                            break;
                        }
                        else {
                            if (this.resultHierachy[this.count].type === "Attrvalue") {
                                self.locateNodes(nodes, itemsToLocate);
                            }
                        }
                    } else {
                        self.selectNode(nodes[j]);
                        this.count = 0;
                        self._oxeservice.setLoader(false);
                        break;
                    }
                } else {
                    if (j == nodes.length - 1) {
                        self.selectNode(nodes[0].parent);
                        this.count = 0;
                        self._oxeservice.setLoader(false);
                        break;
                    }
                }
            }
        }, 1000);
    }

    selectNode(node: INode) {
        var self = this;

        if (node.isClassNode && !node.isOneInstance) {
            self._oxeservice.selectNode(node);
            setTimeout(function () {
                if (document.getElementsByClassName('selectedNode')[0] === undefined) {
                    self.selectNode(node.parent);
                } else
                document.getElementsByClassName('selectedNode')[0].scrollIntoView({ behavior: "auto", block: "center" })
                //self._oxeservice.setLoader(false);
            }, 1000);
        } else {
            self._oxeservice.retrieveData(node)
                .subscribe(() => {
                    this._oxeservice.selectNode(node);
                    this.cd.markForCheck();
                    setTimeout(function () {
                        if (document.getElementsByClassName('selectedNode')[0] === undefined) {
                            self.selectNode(node.parent);
                        } else
                        document.getElementsByClassName('selectedNode')[0].scrollIntoView({ behavior: "auto", block: "center" })
                        //self._oxeservice.setLoader(false);
                    }, 1000);
                });
        }
    }

    public classLastitem1(item, search, i): boolean {
        if (search.searchHierachy[i + 1] != undefined) {
            if (item.type != 'Node' || search.searchHierachy[i + 1].type === 'Attribute')
                return true;
            else
                return false
        } else if (item.type != 'Node')
            return true;
        else
            return false;
    }

    public canLocate(search, i) {
        if (search.searchHierachy[i + 1] != undefined) {
            if (search.searchHierachy[i].canLocate && !search.searchHierachy[i + 1].canLocate) {
                return true
            }
            else
                return false;
        }
        else
            return search.searchHierachy[i].canLocate;
    }

    public canLocateAttr(search, i) {
        if (search.searchHierachy[i + 1] != undefined) {
            if (search.searchHierachy[i].canLocate && !search.searchHierachy[i + 1].canLocate) {
                return true
            }
            else
                return false;
        }
        else {
            return search.searchHierachy[i - 1].canLocate ? search.searchHierachy[i].canLocate : false;
        }
    }

}
